module.exports = __webpack_public_path__ + "img/Number=56.775f547a.png";